import { Avatar } from "@amzn/stencil-react-components/avatar";
import { Chip, ChipBackgroundColor } from "@amzn/stencil-react-components/chip";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import IconMessageSmall from "@amzn/stencil-react-icons/icons/icon-message-small";
import IconPeopleSmall from "@amzn/stencil-react-icons/icons/icon-people-small";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC } from "react";

export interface UseCaseMetaBarProps {
  contributorAlias: string;
  date: string;
  commentCount?: number;
  usedCount?: number;
  tools: string[];
  recommendedAudience?: string[];
}

export const UseCaseMetaBar: FC<UseCaseMetaBarProps> = ({
  contributorAlias,
  date,
  commentCount,
  usedCount,
  tools,
  recommendedAudience,
}) => (
  <Col gridGap="dimensions.spacing.300">
    <Row gridGap="dimensions.spacing.300" alignItems="center">
      <Avatar username={contributorAlias} showFullName={false} showUsername={true} />
      <Text fontSize="T100" color="color.text.secondary">
        {getString("useCases.detail.contributedOn", { date })}
      </Text>
      {commentCount != null && (
        <Row gridGap="dimensions.spacing.100" alignItems="center">
          <IconMessageSmall title={getString("useCases.detail.comments")} />
          <Text fontSize="T100" color="color.text.secondary">
            {getString("useCases.detail.commentsCount", { count: String(commentCount) })}
          </Text>
        </Row>
      )}
      {usedCount != null && (
        <Row gridGap="dimensions.spacing.100" alignItems="center">
          <IconPeopleSmall title={getString("useCases.detail.usedThis")} />
          <Text fontSize="T100" color="color.text.secondary">
            {getString("useCases.detail.usedCount", { count: String(usedCount) })}
          </Text>
        </Row>
      )}
    </Row>

    <Row gridGap="dimensions.spacing.200" alignItems="center">
      <Text fontSize="T100" color="color.text.secondary">
        {getString("useCases.detail.tools")}
      </Text>
      {tools.map((t) => (
        <Chip key={t} backgroundColor={ChipBackgroundColor.Default}>
          {t}
        </Chip>
      ))}
    </Row>

    {recommendedAudience && recommendedAudience.length > 0 && (
      <Row gridGap="dimensions.spacing.200" alignItems="center">
        <Text fontSize="T100" color="color.text.secondary">
          {getString("useCases.detail.audience")}
        </Text>
        {recommendedAudience.map((a) => (
          <Chip key={a} backgroundColor={ChipBackgroundColor.Default}>
            {a}
          </Chip>
        ))}
      </Row>
    )}
  </Col>
);
